import { colors, Icons } from 'bold-ui'
import {
  PublicoAlvoEnum,
  TemaReuniaoEnum,
  TipoAcompanhamentoEnum,
  TipoAtividadeEnum,
  TipoRegistroHistoricoClinico,
} from 'graphql/types.generated'
import { TIPOS_ATIVIDADE_EM_SAUDE } from 'view/atividade-coletiva/model-atividadeColetiva'

import {
  CIAPS_GESTACAO_CODIGOS,
  CIAPS_PUERPERIO_CODIGOS,
  CIDS_GESTACAO_CODIGOS,
  CIDS_PUERPERIO_CODIGOS,
} from '../soap/pre-natal/model-preNatal'

export interface ExternalPaths {
  basePath: string
  vacinacaoPath: string
  agendamentosPath: string
  historicoPath: string
  antropometriaPath: string
}

export interface AcompanhamentosUrlParams {
  redirect?: string
}

export const ciapsAndCidsToSortProblemasRecord: Record<
  TipoAcompanhamentoEnum,
  { ciaps: Set<string>; cids: Set<string> }
> = {
  PRE_NATAL: { ciaps: CIAPS_GESTACAO_CODIGOS, cids: CIDS_GESTACAO_CODIGOS },
  PUERPERIO: { ciaps: CIAPS_PUERPERIO_CODIGOS, cids: CIDS_PUERPERIO_CODIGOS },
}

export const acompanhamentosColorsRecords: Record<TipoAcompanhamentoEnum, string> = {
  PRE_NATAL: colors.purple.c40,
  PUERPERIO: colors.blue.c70,
}

export enum UltimosContatosTabs {
  CONSULTAS = 'Consultas',
  VISITAS_DOMICILIARES = 'Visitas domiciliares',
  ATIVIDADE_COLETIVA = 'Atividade coletiva',
  OUTRAS_CONSULTAS = 'Outras consultas',
}

export const statusVisitaDomiciliarRecord: Record<string, { color: string; icon: Icons; label: string }> = {
  'Visita realizada': { color: colors.green.c40, icon: 'checkCircleOutline', label: 'Realizada' },
  'Visita recusada': { color: colors.red.c40, icon: 'banOutline', label: 'Recusada' },
  Ausente: { color: colors.orange.c40, icon: 'exclamationTriangleOutline', label: 'Ausente' },
}

export const redirectMapping: Record<string, TipoAcompanhamentoEnum> = {
  puerperio: TipoAcompanhamentoEnum.PUERPERIO,
  prenatal: TipoAcompanhamentoEnum.PRE_NATAL,
}

const PUBLICO_ALVO_ATIVIDADE_COLETIVA_PUERPERIO = [
  PublicoAlvoEnum.ADOLESCENTE,
  PublicoAlvoEnum.COMUNIDADE_EM_GERAL,
  PublicoAlvoEnum.CRIANCA_6_A_11_ANOS,
  PublicoAlvoEnum.FAMILIARES,
  PublicoAlvoEnum.GESTANTE,
  PublicoAlvoEnum.HOMEM,
  PublicoAlvoEnum.MULHER,
  PublicoAlvoEnum.OUTROS,
  PublicoAlvoEnum.PESSOAS_COM_DOENCAS_CRONICAS,
  PublicoAlvoEnum.PESSOAS_COM_SOFRIMENTO_TRANSTORNO_MENTAL,
  PublicoAlvoEnum.PROFISSIONAL_DE_EDUCACAO,
  PublicoAlvoEnum.USUARIO_DE_ALCOOL,
  PublicoAlvoEnum.USUARIO_DE_OUTRAS_DROGAS,
  PublicoAlvoEnum.USUARIO_DE_TABACO,
]

export const getFiltrosAtividadeColetiva = (isAcompanhamentoPuerperio: boolean) => ({
  tiposAtividade: [...TIPOS_ATIVIDADE_EM_SAUDE, TipoAtividadeEnum.REUNIAO_DE_EQUIPE],
  temasReuniao: [TemaReuniaoEnum.DISCUSSAO_DE_CASO_PROJETO_TERAPEUTICO_SINGULAR],
  publicoAlvo: isAcompanhamentoPuerperio ? PUBLICO_ALVO_ATIVIDADE_COLETIVA_PUERPERIO : [PublicoAlvoEnum.GESTANTE],
})

export const FILTROS_OUTRAS_CONSULTAS = {
  tiposRegistros: [
    TipoRegistroHistoricoClinico.CONSULTA,
    TipoRegistroHistoricoClinico.ATENDIMENTO_ODONTOLOGICO,
    TipoRegistroHistoricoClinico.VACINACAO,
    TipoRegistroHistoricoClinico.ATENDIMENTO_DOMICILIAR,
    TipoRegistroHistoricoClinico.AVALIACAO_ELEGIBILIDADE,
    TipoRegistroHistoricoClinico.CONSUMO_ALIMENTAR,
    TipoRegistroHistoricoClinico.ATENDIMENTO_PROCEDIMENTOS,
    TipoRegistroHistoricoClinico.CUIDADO_COMPARTILHADO,
  ],
}
